import { useState, useEffect, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "./useAuth";

// Credits per plan purchase
export const PLAN_CREDITS = {
  free: 3,      // Default free credits
  pro: 25,      // ₹49 = 25 credits
  premium: 50,  // ₹99 = 50 credits
} as const;

export function useCredits() {
  const { user } = useAuth();
  const [credits, setCredits] = useState<number>(0);
  const [loading, setLoading] = useState(true);

  const fetchCredits = useCallback(async () => {
    if (!user) {
      setCredits(0);
      setLoading(false);
      return;
    }

    try {
      // Use raw query to get credits since types may not be updated
      const { data, error } = await supabase
        .from('profiles')
        .select('*')
        .eq('id', user.id)
        .maybeSingle();

      if (error) {
        console.error('Error fetching credits:', error);
        return;
      }

      // Access credits_remaining from the data object
      const creditsRemaining = (data as any)?.credits_remaining ?? 0;
      setCredits(creditsRemaining);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    fetchCredits();
  }, [fetchCredits]);

  const refetch = () => {
    fetchCredits();
  };

  return {
    credits,
    loading,
    refetch,
    hasCredits: credits > 0,
  };
}
